export class StudentHousingConst {
    public static readonly EventEventType = -10_000;
}
